import { useClient } from '@composables/use-clients';
import { urls } from '@api/urls';
import { UserLinkType } from '@api/types';
import { PostRequestArgsType } from '@api/v1/types';
import { withTryCatch } from '@api/v1/error-handlers';

export type PostCurrentUserLinkPayloadType = (
  Pick<UserLinkType, 'name' | 'url' | 'displayOrder'>
);

export const apiFetchCurrentUserLinks = async ({
  errorConfig = {},
  callbacks = {},
}) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.get({
      url: urls.v1.currentUserLinks(),
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiAddCurrentUserLink = async ({
  payload,
  errorConfig = {},
  callbacks = {},
}: PostRequestArgsType<PostCurrentUserLinkPayloadType>) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.post({
      url: urls.v1.currentUserLinks(),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiDeleteCurrentUserLink = async ({
  userLinkId,
  errorConfig = {},
  callbacks = {},
}) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.delete({
      url: urls.v1.currentUserLinks({ userLinkId }),
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
